import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const careItems = [
  {
    number: "01",
    title: <><span className="red">Community</span> Development</>,
    description:
      "We actively support developments that improve neighborhoods, encourage sustainable living, and contribute to long-term economic growth. Every project is selected with the goal of creating positive community impact.",
  },
  {
    number: "02",
    title: <>Our <span className="red">Focus</span></>,
    description:
      "Our focus is on delivering high-quality real estate opportunities backed by transparency, market expertise, and exceptional customer service. Whether buying, selling, or investing, we strive to make every decision easier and every investment more valuable.",
    reverse: true,
  },
  {
    number: "03",
    title: <>Our <span className="red">Mission & Values</span></>,
    description:
      "At JamboBay, our mission is to transform the real estate experience through integrity, innovation, and customer-first service. We are committed to helping individuals and businesses make confident property decisions while building long-term trust through professionalism and excellence.",
  },
  {
    number: "04",
    title: <span className="red">Integrity</span>,
    description:
      "Trust is the foundation of everything we do. We maintain the highest standards of ethics, fairness, and accountability in every transaction and partnership.",
    reverse: true,
  },
  {
    number: "05",
    title: <><span className="red">Long-Term</span> Relationships</>,
    description:
      "We believe success is measured not by one transaction but by lasting relationships. Our commitment continues well beyond the closing process, supporting our clients throughout their real estate journey.",
  },
];

const WhatWeCareAbout = () => {
  return (
    <section className="what-we-care-about">
      <Container>
        <Row>
          <Col md={12}>
            <div className="common-header">
              <h2>
                What We Care <span className="red">About</span>
              </h2>
              <p>
                Our mission extends beyond property transactions. We believe in creating thriving communities where people can live, work, and grow with confidence. By promoting ethical business practices, sustainable development, and customer satisfaction, we aim to build neighborhoods that enhance lifestyles while delivering lasting value for investors and homeowners alike.
              </p>
            </div>
            <div className="care-items">
              {careItems.map((item) => (
                <div
                  className={`care-item${item.reverse ? " reverse" : ""}`}
                  key={item.number}
                >
                  <span className="care-number">{item.number}</span>
                  <div className="care-card">
                    <h3 className="care-title">{item.title}</h3>
                    <p className="care-description">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhatWeCareAbout;
